import { createFileRoute } from "@tanstack/react-router";
import { LegalPage } from "@/lib/legal-content";

export const Route = createFileRoute("/disclaimer")({
  component: DisclaimerPage,
  head: () => ({
    meta: [
      { title: "Disclaimer — CoderLity" },
      { name: "description", content: "General disclaimer for CoderLity's website, content and services." },
      { property: "og:url", content: "/disclaimer" },
    ],
    links: [{ rel: "canonical", href: "https://coderlity.com/disclaimer" }],
  }),
});

function DisclaimerPage() {
  return (
    <LegalPage
      eyebrow="Legal"
      title="Disclaimer"
      sub="General website and services disclaimer."
      updated="May 1, 2026"
      sections={[
        { heading: "General information", body: "Content on this website is provided for general information only and does not constitute professional, legal, financial or business advice." },
        { heading: "No warranty", body: "Services and information are provided 'as is'. To the maximum extent permitted by law, we disclaim all warranties, express or implied." },
        { heading: "External links", body: "We link to third-party websites for convenience only; we don't endorse or control them and aren't responsible for their content." },
        { heading: "Testimonials & results", body: "Testimonials reflect individual client experiences and are not typical or guaranteed. Marketing and software results depend on many factors." },
        { heading: "Limitation of liability", body: "CoderLity is not liable for indirect, incidental or consequential damages arising from use of this website or our services." },
      ]}
    />
  );
}
